<template>
  <v-card flat>
    <mapping-summary
      :field-mapping="realTimeMapping"
      :lhs-values="emailTemplateFields"
      :rhs-values="datasourceFields"
    />
     <v-btn
        @click.stop="showMapper = true"
        class="mb-4"
        small
      >
      <v-icon left>mdi-wrench</v-icon>
        Configure Mapping
      </v-btn>

      <!-- v-if on dialog destroys the dialog on close so cancel works correctly -->
      <v-dialog
        v-model="showMapper"
        v-show="showMapper"
        eager
        persistent
        max-width="80vw"
        max-height="80vh"
      >
        <v-card>
          <field-map-editor
            v-model="value"
            :lhs-title="lhsTitle"
            :rhs-title="rhsTitle"
            :default-value-title="defaultValueTitle"
            :lhs-values="emailTemplateFields"
            :rhs-values="datasourceFields"
            :mapping-presets="mappingDefaultsFromDatasource"
            @on-mapping-editor-close="showMapper = false"
            @on-mapping-editor-save="saveMapping"
            @on-mapping-change="interimMapping = $event"
          />
        </v-card>
      </v-dialog>
  </v-card>
</template>

<script>
import { intersection, difference, uniq, flatten, append, pathOr, propOr, equals } from 'ramda'
import { mapState } from 'vuex'
import FieldMapEditor from '@/components/mapping/FieldMapEditor'
import MappingSummary from '@/components/mapping/MappingSummary'
import { StatsAndErrors } from '@/components/mapping'

export default {
  name: 'mapping-dialog',
  components: {
    [FieldMapEditor.name]: FieldMapEditor,
    [MappingSummary.name]: MappingSummary
  },
  props: {
    // value is the field mapping { lhs: '', rhs: '', default_value: ''}
    value: {
      required: true,
      type: Array
    },
    datasource: {
      required: true,
      type: Object,
      default: () => {}
    },
    emailTemplate: {
      required: true,
      type: Object,
      default: () => {}
    },
    lhsTitle: {
      type: String,
      required: true
    },
    rhsTitle: {
      type: String,
      required: true
    },
    defaultValueTitle: {
      type: String,
      require: false,
      default: 'Fallback Value'
    },
    errorMessages: {
      type: Array,
      required: false
    }
  },
  data () {
    return {
      showMapper: false,
      interimMapping: [] // for mapping msg
    }
  },
  computed: {
    ...mapState('EmailCampaignStore', ['userMappableMergeTags', 'requiredFieldMappingTags', 'userNonMappableMergeTags', 'allMergeTags']),
    emailTemplateFields: function () {
      // emailTemplateFields - (any not in user editable list) + required fields
      if (this.emailTemplate && this.emailTemplate.hasOwnProperty('id')) {
        const commonFields = intersection(
          this.emailTemplate.fields || [],
          this.userMappableMergeTags
        )
        let customMergeTags = []
        if (!this.emailTemplate.app_only_merge_tags) {
          customMergeTags = difference(
            this.emailTemplate.fields || [],
            this.allMergeTags
          )
        }
        const uniqList = uniq(
          flatten(append(customMergeTags, append(commonFields, this.requiredFieldMappingTags)))
        )
        return uniqList
      } else {
        return []
      }
    },
    datasourceFields: function () {
      if (this.datasource) {
        return pathOr([], ['meta', 'headers'], this.datasource)
      } else {
        return []
      }
    },
    // Dms Datasource has defaulted values pre-set
    mappingDefaultsFromDatasource: function () {
      return pathOr([], ['meta', 'default_mapping'], this.datasource)
    },
    isDmsDatasource: function () {
      return equals(propOr('na', 'type', this.datasource), 'DmsDatasource')
    },
    // we may not have received an event yet because dialog not loaded
    // return interim first then current val to we always show a mapping
    // interim mapping is the live mapping that has not yet been pushed to parent component
    // original value is the initial field mapping
    realTimeMapping: function () {
      return this.interimMapping.length === 0 ? this.value : this.interimMapping
    }
  },
  watch: {
    interimMapping (newVal) {
      // this is the key to automap dms datasources - save on receive
      if (this.isDmsDatasource) {
        this.saveMapping(this.interimMapping)
      }
    }
  },
  methods: {
    saveMapping (mapping) {
      this.$emit('input', mapping)
    },
    isMappingValid () {
      return StatsAndErrors(this.realTimeMapping, this.emailTemplateFields, this.datasourceFields).isValid
    },
    openMapper () {
      this.showMapper = true
    }
  },
  mounted: function () {
    this.$store.dispatch('EmailCampaignStore/getUserMappableMergeTags')
    this.$store.dispatch('EmailCampaignStore/getUserNonMappableMergeTags')
    this.$store.dispatch('EmailCampaignStore/getAllMergeTags')
    this.$store.dispatch('EmailCampaignStore/getRequiredFieldMappingTags')
  }

}
</script>
